import { defineStore } from 'pinia'
import axios from 'axios'
import { ref,reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {formatDate} from '../utilities/_helpers.js'
import { useReportStore } from './ReportStore.js'

export const useUserStore = defineStore('UserStore', {
    state: () => {
        return {
            user: reactive({
                defaultCreditMonitoringAgency: useReportStore().creditfixrrreports
            }),
            profile:reactive({
                showSubview: false,
                canceled: false,
                user_subscription_ended: false,
            }),
            name:'',
            messaage:ref(),
            app_status:ref(false),
            isValid:ref(false),
            signingUp:ref(false),
            Submit:ref('Sign Up'),
            error:ref([]),
            phone:ref(null),
            state:ref(),
            memberSignupError:ref(),
            memberShowError:ref(false),
            termsAndAgreementsError:ref(),
            cityTown:ref(),
            zipcode:ref(),
            defaultCountry:ref(),
            authenticating:false,
            remember:false,
            loginUser:'Sign-In',
            disabled:'',
            route: useRoute(),
            router: useRouter(),
            userDashboard: reactive({}),
            checkValidUserDispute : reactive({}),
            roles:reactive({}),
            createUser:ref('Create User'),
            creatingUser:ref(false),
            showEditUser:ref(false),
            deactivateId:ref(),
            states:reactive({}),
            adminUserview:reactive({}),
            collapsed:ref(false),
            leftCollapse:ref(false),
            rightCollapse:ref(false),
            config: {
                wrap: true,
                static:true,
                altFormat: 'm-j-Y',
                altInput: true,
                dateFormat: 'm-d-Y',
            },
            deactivate_reasons:reactive({}),
            deactivate_type:ref(),
            DEACTIVATE_REASON_1:1,
            DEACTIVATE_REASON_2:2,
            DEACTIVATE_ACCOUNT : 1,
            CANCEL_SUBSCRIPTION : 2,
            deactivate_confirm_text:'DEACTIVATE',
            showCropperModel:ref(false),
            imgChanged:reactive({
                ssn_image:ref(false),
                address_verification_image:ref(false),
                lincence_state_image:ref(false),
                id_theft_affidavit:ref(false)
            }),
            img:ref(),
            file:ref(),
            imageType:ref(),
            formatDate:formatDate,
            referrals: reactive({}),
            affiliate_info:reactive({}),
            super_admin: "super_admin",
            author: "author",
            keySaves:ref(0),
            saveType:ref(),
            course:reactive({}),
            agreementType:ref()
        }
    },
    actions: {
        async fetchUser() {
            try {
                let route;
                if(_.includes(['client-message'], this.route.name)){
                    route = this.router.resolve(
                        {
                            name: 'fetch-client'
                        }
                    );
                }else{
                    route = this.router.resolve(
                        {
                            name: 'user',
                            params: {
                                client: this.route.params.client,
                                team: this.route.params.team,
                            }
                        }
                    );
                }
                this.user = await axios.get(route.href)
                .then(function (response) {
                    return response.data.data.user;
                });
            } catch (error) {
                console.log(error);
            }
        },
        async fetchuserDashboard() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'diy-dashboard',
                    }
                );
                this.userDashboard = await axios.post(route.href)
                .then(function (response) {
                    return response.data.data;
                });
            } catch (error) {

            }
        },
        async fetchCheckValidUserDispute() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'check-valid-user-dispute',
                        params: {
                            client: this.route.params.client,
                            team: this.route.params.team
                        }
                    }
                );
                this.checkValidUserDispute = await axios.post(route.href)
                .then(function (response) {
                    return response.data.data;
                });
            } catch (error) {
            }
        },
        async fetchRoles() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'admin-get-role-list',
                    }
                );
                this.roles = await axios.get(route.href)
                .then(function (response) {
                    return response.data.data.roles;
                });
            } catch (error) {
            }
        },
        // /rbac/roles/list
        async fetchAdminRoles() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'admin-role-list',
                    }
                );
                this.dataRoles = await axios.get(route.href)
                .then(function (response) {
                    return response.data.data.dataroles;
                });
            } catch (error) {
            }
        },
        async fetchStates() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'states',
                    }
                );
                this.states = await axios.get(route.href)
                .then(function (response) {
                    return response.data.data;
                });
            } catch (error) {
            }
        },
        updateProfile() {
            let client = this.route.params.client;
            if(this.route.name == 'client-dashboard-detail') {
                client = this.user.id;
            }
            const route = this.router.resolve(
                {
                    name: 'update-client-profile',
                    params: {
                        client: client,
                        team: this.route.params.team
                    }
                }
            );
            axios.post(
                route.href,
                {
                    firstname: this.user.firstname,
                    middle_name: this.user.middle_name,
                    lastname: this.user.lastname,
                    dob: this.formatDate(this.user.dob,'YYYY-MM-DD'),
                    address: this.user.address,
                    address_line_2: this.user.address_line_2,
                    city: this.user.city,
                    state_id: this.user.state_id,
                    zipcode: this.user.zipcode,
                    phone: this.user.phone,
                }
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        },
        updatePhoneNumber(PhoneNumber) {
            this.user.phone = PhoneNumber;
        },
        async fetchDeactivateReasons() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'deactivate-reasons',
                    }
                );
                this.deactivate_reasons = await axios.get(route.href)
                .then(function (response) {
                    return response.data.data;
                });
            } catch (error) {

            }
        },
        fetchUserProfile(){
            let status ={
              status:"0"
            };
            let $this = this;
            const route = this.router.resolve(
                {
                    name: 'profile',
                }
            );
            axios.post(route.href,status).then(({data})=>{
                if(data.error == false) {
                    $this.profile=data.data
                    return;
                }
            }).catch(function(error) {
                // toastr.error(error.response.data.response_msg, 'Error!');
            });
          },
          fetchUserReferrals(){

            let $this = this;
            const route = this.router.resolve(
                {
                    name: 'referral_list',
                }
            );
            axios.post(route.href).then(({data})=>{
                if(data.error == false) {
                    $this.referrals=data.data
                    return;
                }
            }).catch(function(error) {
                // toastr.error(error.response.data.response_msg, 'Error!');
            });
          },
          saveCroppedImage(event,image_save_type){
            this.img = this.file;
            this.showCropperModel = false;
            this.keySaves++;
            this.saveType = image_save_type
          },
          closeCropper(){
            this.showCropperModel = false;
            this.imgChanged.ssn_image = false
            this.imgChanged.address_verification_image = false
            this.imgChanged.lincence_state_image = false
            this.img = null
          },
    },
    getters: {
    },
})

